<template>
    <Button
        color="carbon-400"
        :aria-label="$tr('gameContainer.hideBar')"
        interfaceTarget="hide-desktop-bar"
        :class="$style.button_override"
        @click="emit('click')"
    >
        <Icon name="eye" />
        <Typography
            size="m"
            type="label"
            accent
            :responsive="false"
            :class="$style.button_label"
        >
            {{ $tr('gameContainer.hideBar') }}
        </Typography>
    </Button>
</template>

<script lang="ts" setup>
import Button from '@/components/Buttons/Button.vue'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'

const emit = defineEmits<{
    click: []
}>()
</script>

<style module>
.button_override {
    padding: 8px;
}

.button_label {
    display: none;
}

@media (--desktop-large-plus) {
    .button_override {
        padding: 13px 16px;
    }
    .button_label {
        display: block;
    }
}
</style>
